import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
  Input,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';

import { accordionAnimation, arrowRotate90Animation } from '../common-ui';

import { AccordionService } from './accordion.service';

@Component({
  selector: 'app-accordion',
  template: '<ng-content></ng-content>',
  styleUrls: ['./accordion.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: { class: 'app-accordion' },
})
export class AccordionComponent {}

@Component({
  selector: 'app-accordion-item',
  template: `
    <ng-content select="app-accordion-title"></ng-content>
    <div *ngIf="service.expanded$ | async" [@toggle]>
      <ng-container *ngTemplateOutlet="contentEl"></ng-container>
    </div>
    <ng-template #contentEl>
      <ng-content select="app-accordion-content"></ng-content>
    </ng-template>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  animations: [accordionAnimation],
  providers: [AccordionService],
  host: { class: 'app-accordion-item', '[class.app-accordion-expanded]': 'expanded' },
})
export class AccordionItemComponent implements OnInit {
  @Input() expanded: boolean;

  constructor(public service: AccordionService) {}

  ngOnInit(): void {
    this.service.initPanel(this.expanded);
  }
}

@Component({
  selector: 'app-accordion-title',
  template: `
    <h3 class="flex flex-row justify-start items-center">
      <mat-icon [@arrowRotate90]="expandedState">chevron_right</mat-icon>
      <ng-content></ng-content>
    </h3>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  animations: [arrowRotate90Animation],
  host: { class: 'app-accordion-title' },
})
export class AccordionTitleComponent {
  @HostListener('click') toggle(): void {
    this.accordionItem.expanded = !this.accordionItem.expanded;
    this.accordionItem.service.toggle(this.accordionItem.expanded);
  }

  constructor(public accordionItem: AccordionItemComponent) {}

  get expandedState(): 'expanded' | 'collapsed' {
    return this.accordionItem.expanded ? 'expanded' : 'collapsed';
  }
}

@Component({
  selector: 'app-accordion-content',
  template: '<ng-content></ng-content>',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: { class: 'app-accordion-content' },
})
export class AccordionContentComponent {}
